import { render, staticRenderFns } from "./labeltem.vue?vue&type=template&id=6aa9c292&scoped=true"
import script from "./labeltem.vue?vue&type=script&lang=js"
export * from "./labeltem.vue?vue&type=script&lang=js"
import style0 from "./labeltem.vue?vue&type=style&index=0&id=6aa9c292&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa9c292",
  null
  
)

export default component.exports